import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { allTorneosAction } from '../TorneosAction';

const SelectFieldTorneosComponent = ({
  onChange,
  value = '',
  data,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const torneosStore = Redux.useSelector((state) => state.torneos);

  const [torneos, setTorneos] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      torneosStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setTorneos(items);
    } else {
      if (data) {
        setTorneos(data);
      } else {
        setTorneos(torneosStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && torneosStore.all.length === 0) {
        await allTorneosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.torneos.name}`}>
        {CONST.torneos.label}
      </InputLabel>
      <Select
        id={CONST.torneos.name}
        value={value?.toString()}
        labelId={`label_${CONST.torneos.name}`}
        label={CONST.torneos.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {torneos.map((el, index) => {
          return (
            <MenuItem key={`torneos-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-torneos"
      opt={torneos}
      type={CONST.torneos.name}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l="Torneos"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldTorneosComponent;
